import { defineMessages } from "react-intl";

import {
	statusMessages,
	subjectMessages,
	validator
} from "lib/build/forms/basic-health/patientCondition";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientCondition: {
		id: "form.patient_condition",
		defaultMessage: "Státusz jelentés"
	},
	subject: {
		id: "form.patient_condition.subject",
		defaultMessage: "Tárgy"
	},
	description: {
		id: "form.patient_condition.description",
		defaultMessage: "Állapotváltozás leírása"
	},
	status: {
		id: "form.patient_condition.status",
		defaultMessage: "Páciens státusza"
	}
});

const fields: { [key: string]: FieldData } = {
	subject: {
		type: "field",
		path: ["subject"],
		label: messages.subject,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: subjectMessages } }
	},
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	},
	status: {
		type: "field",
		path: ["status"],
		label: messages.status,
		errorMessages: genericErrorMessages,
		input: { type: "select", props: { labels: statusMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{ width: 6, field: fields.subject },
				{ width: 6, field: fields.status }
			]
		},
		{ columns: [{ width: 12, field: fields.description }] }
	]
};

export const node: LeafNode = {
	id: "bh_patientCondition",
	value: {
		schemaId: "patientCondition",
		title: messages.patientCondition,
		validator,
		fieldset,
		isLimitedAccess: true,
		applyCurrentDate: true,
		showTimeInput: true,
		returnTo: "status-history",
		defaults: [
			{
				path: ["status"],
				query: {
					interpretation: {
						vocab: "basic_health",
						code: "patient_status"
					}
				}
			}
		]
	}
};
